import React from "react";
import { TitledContent } from "./TitledContent";
import AccountOTPSettingsDialog from "./AccountOTPSettingsDialog";
import { FormattedMessage } from "react-intl";
import CRUDForm from "./CRUDForm";
import { useOnUserDataChange, useUserData } from "../context/UserDataProvider";

const AccountSettingsPage: React.FC = () => {
    const userData = useUserData();
    const onUserDataChange = useOnUserDataChange();
    console.log("Account settings rendering");

    return (
        <TitledContent
            title={<FormattedMessage id="account.general_settings" />}
            action={window.features["totp"] ? <AccountOTPSettingsDialog /> : null}
        >
            <CRUDForm
                resourceName="simplified_user"
                action="update"
                id={userData.userId}
                onSuccess={() => {
                    console.log("Account settings updated");
                    onUserDataChange();
                }}
            />
        </TitledContent>
    );
};

export default AccountSettingsPage;
